import React from 'react'
import { useSharedStyles } from '../../Settings/useSharedStyles'
import { Box, Typography } from '@mui/material'
import { MobileIcon, Trash } from '@/shared/ui/Icons'
import { DataLine } from '../../../components/settings/components/DataLine'
import { useTranslation } from 'react-i18next'

const DevicesSection = () => {
    const { t: translate } = useTranslation()
    const {
        titleStyle,
        titleContainer,
        sectionStyle,
        iconContainer,
        dataContainer,
        deviceCaptionStyle,
    } = useSharedStyles()
    return (
        <Box sx={sectionStyle}>
            <Box sx={titleContainer}>
                <Box sx={iconContainer}>
                    <MobileIcon />
                </Box>
                <Typography ml="24px" sx={titleStyle}>
                    {translate('devices')}
                </Typography>
            </Box>
            <Box sx={dataContainer}>
                <Typography sx={deviceCaptionStyle}>
                    {translate('devicesCaption')}
                </Typography>
                <Box display="flex" columnGap="8px">
                    <DataLine fieldName="ip" value="Telefon" />

                    <Box mt="2px">
                        <Trash />
                    </Box>
                </Box>
                <Box display="flex" columnGap="8px">
                    <DataLine fieldName="ip" value="Komputer" />
                    <Box mt="2px">
                        <Trash />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default DevicesSection
